import { createGa4Provider } from '@/shared/lib/analytics/providers/ga4'
import { createMatomoProvider } from '@/shared/lib/analytics/providers/matomo'
import { createPlausibleProvider } from '@/shared/lib/analytics/providers/plausible'
import { createUmamiProvider } from '@/shared/lib/analytics/providers/umami'
import { createAnalyticsRuntime } from '@/shared/lib/analytics/runtime'
import type { AnalyticsEventName, AnalyticsEventMap } from '@/shared/lib/analytics/events'

export const analyticsRuntime = createAnalyticsRuntime([
  createUmamiProvider(),
  createPlausibleProvider(),
  createMatomoProvider(),
  createGa4Provider(),
])

export function trackPageview(pathname: string): void {
  analyticsRuntime.pageview(pathname)
}

export function trackEvent<N extends AnalyticsEventName>(name: N, props: AnalyticsEventMap[N]): void {
  analyticsRuntime.track(name, props)
}

export type { AnalyticsEventMap, AnalyticsEventName }
